import assign from "lodash/assign";
import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import segmentCreation from "./segment";
import segmentList from "./segmentList";
import employees from "./employees";
import insights from "./insights";
import creatAccount from "./createAccount";
import createClientAccount from "./createClientAccount";
import clients from "./clients";
import app from "./app";
import settings from "./settings";
import { LOGOUT } from "../actions/App";
import myProfile from "./profile";
import dashboard from "./dashboard";
import tagsInfo from "./tagsInfo";
import clientBusinessAndUser from "./clientBusinessAndUser";
import subscriptionInfo from "./subscriptionInfo";
import insightsInfo from "./insightsInfo";
import campaigns from "./campaigns";

const reducers = assign(
  {
    routing: routerReducer,
    app,
  },
  segmentCreation,
  segmentList,
  employees,
  creatAccount,
  createClientAccount,
  clients,
  insights,
  myProfile,
  settings,
  dashboard,
  tagsInfo,
  clientBusinessAndUser,
  subscriptionInfo,
  insightsInfo,
  campaigns,
);

const combinedReducers = combineReducers(reducers);

export default (state, action) => {
  if (action.type === LOGOUT) {
    const { routing } = state;
    state = { routing };
  }
  return combinedReducers(state, action);
};



// WEBPACK FOOTER //
// ./src/reducers/index.js